import { AnalyticsStore } from 'bernie-plugin-mobx';
import { ClientLogger } from 'bernie-client';
import AffiliateHubLogger from '../affiliate-hub-logger';
import { getUserAnalyticsMicroMessage } from '.';
import { PzStore, UserAuthStore } from 'src/stores';

const logger = new AffiliateHubLogger(ClientLogger.getLoggerWithIdentifier(`analytic_event`));

const analyticsEvent = (
  analytics: AnalyticsStore,
  userAuth: UserAuthStore,
  pzStore: PzStore,
  event: string,
  link: string,
  microMessages: any[] = [],
): void => {
  if (analytics?.trackEvent) {
    analytics.trackEvent(
      event,
      link,
      null, // omnitureData
      null, // events
      true, // trackImmediate
      [getUserAnalyticsMicroMessage(userAuth.currentUserDetails, pzStore.pzPublisher), ...microMessages],
    );
  } else {
    // TODO: Store these "lost" analytics events and re-publish when we can
    logger.warn(`event=analytics_store_missed_event, event=${event}, link=${link}`, microMessages);
  }
};

export { analyticsEvent };
